import r from"./_isStrictComparable.js";import t from"./keys.js";var a=r,o=t;var e=function(r){for(var t=o(r),e=t.length;e--;){var f=t[e],i=r[f];t[e]=[f,i,a(i)]}return t};export{e as default};
//# sourceMappingURL=_getMatchData.js.map
